import React from 'react';
import { useTaskState } from '../../../context/TaskContext';
import ViewTaskRefactored from '../ViewTask/ViewTaskRefactored';
import AddTaskRefactored from '../AddTask/AddTaskRefactored';
import { useTaskFromUrl } from 'modules/TasksV2/hooks';

export default function TaskContainer() {
  const { showViewTask, showAddTask } = useTaskState();
  useTaskFromUrl();

  return (
    <>
      {showViewTask && <ViewTaskRefactored />}
      {showAddTask && <AddTaskRefactored />}
    </>
  );
}
